<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col cols="12">
                    <BaseCard
                        title="Sale Order Entry"
                        icon="mdi-cart-outline"
                        vCardTextClass="pa-2"
                    >
                        <v-form @submit.prevent="submitForm(currentStatus)" ref="" id="">
                            <v-row dense>
                                <!-- Main Details Card (Left Side) -->
                                <v-col md="3" cols="12">
                                    <v-card elevation="0" border rounded="lg" class="pa-2 h-100">
                                        <div class="d-flex align-center mb-4">
                                            <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                                                <v-icon size="20">mdi-information-outline</v-icon>
                                            </v-avatar>
                                            <div>
                                                <div class="text-subtitle-1 font-weight-medium">Main details</div>
                                                <div class="text-caption text-medium-emphasis">Provide main information</div>
                                            </div>
                                        </div>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-autocomplete 
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="workorder_id.value.value"
                                                    :items="filteredWorkOrderList" 
                                                    :item-title="(item) => `${item.code}`"
                                                    item-value="id" 
                                                    @update:modelValue="onWorkorderChange"
                                                    :error-messages="workorder_id.errorMessage.value" 
                                                    autocomplete="off"
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                    <template #label>
                                                        Work Order
                                                    </template>
                                                </v-autocomplete>

                                                <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    density="compact"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="sale_order_date.value.value"
                                                    :error-messages="sale_order_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable>
                                                    <template #label>
                                                        Sale Order Date <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>

                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="order_category.value.value"
                                                    :items="[{ name: 'general', display_text: 'General' }, { name: 'production', display_text: 'Production' }]"
                                                    :item-title="(item) => `${item.display_text}`" 
                                                    item-value="name"
                                                    :error-messages="order_category.errorMessage.value" 
                                                    autocomplete="off"
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                    <template #label>
                                                        Order Category
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>

                                                <v-autocomplete 
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="customer_id.value.value"
                                                    :items="getCustomerMapList"
                                                    :item-title="item => `${item?.customer?.company_name}` ?? 'N/A'"
                                                    item-value="customer_id"
                                                    :error-messages="customer_id.errorMessage.value"
                                                    autocomplete="off" 
                                                    @update:model-value="onCustomerChange"
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                    <template #label>
                                                        Customer Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>

                                                <v-date-input
                                                    input-format="dd/mm/yyyy" 
                                                    density="compact"
                                                    prepend-icon="" 
                                                    prepend-inner-icon="mdi-calendar" 
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="shipping_date.value.value"
                                                    :error-messages="shipping_date.errorMessage.value" 
                                                    autocomplete="off"
                                                    clearable>
                                                    <template #label>
                                                        Delivery Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>

                                                <v-autocomplete 
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="delivery_address.value.value"
                                                    :items="contactsAddressList"
                                                    :item-title="item => `${item?.address}`"
                                                    item-value="address"
                                                    :error-messages="delivery_address.errorMessage.value"
                                                    autocomplete="off" 
                                                    :loading="contactAddressLoading"
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                    <template #label>
                                                        Delivery Address
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>

                                                <v-text-field 
                                                    label="PO/Ref No"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="po_no.value.value" 
                                                    :error-messages="po_no.errorMessage.value"
                                                    autocomplete="off" 
                                                    clearable>
                                                </v-text-field>

                                                <v-date-input
                                                    input-format="dd/mm/yyyy" 
                                                    density="compact"
                                                    prepend-icon="" 
                                                    prepend-inner-icon="mdi-calendar" 
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="po_date.value.value"
                                                    :error-messages="po_date.errorMessage.value" 
                                                    autocomplete="off"
                                                    clearable>
                                                    <template #label>
                                                        PO Date
                                                    </template>
                                                </v-date-input>

                                                <v-autocomplete 
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="payment_bank_id.value.value"
                                                    :items="getLcBankList" 
                                                    :item-title="item => `${item.name}-${item.branch}` ?? 'N/A'"
                                                    item-value="id" 
                                                    :error-messages="payment_bank_id.errorMessage.value" 
                                                    autocomplete="off"
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                    <template #label>
                                                        Payment Bank
                                                    </template>
                                                </v-autocomplete>

                                                <v-autocomplete 
                                                    label="Sales Person" 
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4" 
                                                    v-model="sales_person_id.value.value"
                                                    :items="getHrmEmployeeList"
                                                    :item-title="item => `${item.code}-${item.name}` ?? 'N/A'"
                                                    item-value="id"
                                                    :error-messages="sales_person_id.errorMessage.value"
                                                    autocomplete="off" 
                                                    clearable
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                                >
                                                </v-autocomplete>

                                                <v-text-field 
                                                    label="Sale Order By" 
                                                    density="compact" 
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="saleOrder_by.value.value"
                                                    :error-messages="saleOrder_by.errorMessage.value" 
                                                    autocomplete="off"
                                                    :disabled="true" clearable>
                                                </v-text-field>

                                                <v-text-field 
                                                    label="Sale Order By Mobile" 
                                                    density="compact" 
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="saleOrder_by_mobile.value.value"
                                                    :error-messages="saleOrder_by.errorMessage.value" 
                                                    autocomplete="off"
                                                    :disabled="true" 
                                                    clearable>
                                                </v-text-field>

                                                <v-text-field 
                                                    label="Sale Order By Email" 
                                                    density="compact" 
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="saleOrder_by_email.value.value"
                                                    :error-messages="saleOrder_by_email.errorMessage.value" 
                                                    :disabled="true"
                                                    autocomplete="off" 
                                                    clearable>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>

                                <!-- Item Info Card (Right Side) -->
                                <v-col md="9" cols="12">
                                    <v-card elevation="0" border rounded="lg">
                                        <div class="d-flex align-center pt-4 px-4">
                                            <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                                                <v-icon size="20">mdi-format-list-bulleted</v-icon>
                                            </v-avatar>
                                            <div>
                                                <div class="text-subtitle-1 font-weight-medium">Order items</div>
                                                <div class="text-caption text-medium-emphasis">
                                                    Search and add products to this order
                                                </div>
                                            </div>
                                        </div>
                                        <v-row class="mt-2" justify="center">
                                        <v-col cols="12" md="9" lg="8">
                                            <v-autocomplete 
                                                label="Search Product Name" 
                                                variant="outlined"
                                                density="compact" 
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" 
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart" 
                                                @keydown.enter="addCart"
                                                autocomplete="off" 
                                                hide-details="auto"
                                                clearable
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                            >
                                            </v-autocomplete>

                                            <input v-model="sale_order_master_id.value.value" type="hidden" />
                                        </v-col>
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row>
                                        <v-col cols="12">
                                            <v-card elevation="0" class="overflow-x-auto">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                style="max-height: 600px; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-center" style="width: 10%">Code</th>

                                                        <th class="text-left" style="width: 25%">
                                                            Product Name
                                                        </th>

                                                        <th class="text-center" style="width: 10%">Unit</th>

                                                        <th class="text-left" style="width: 10%">
                                                            Quantity
                                                        </th>

                                                        <th v-if="isFreeItem" class="text-left" style="width: 10%">
                                                            Free Quantity
                                                        </th>

                                                        <th class="text-left" style="width: 15%">
                                                            Price
                                                        </th>

                                                        <th class="text-center" style="width: 20%">
                                                          Lot No.
                                                        </th>

                                                        <th class="text-center" style="width: 15%">
                                                            Amount
                                                        </th>

                                                        <th class="text-center" style="width: 10%">

                                                          Desc.
                                                        </th>
                                                        <th class="text-right" style="width: 5%">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <template v-for="(item, index) in cart"  :key="index">
                                                        <tr 
                                                            v-if="cart.length > 0"
                                                                @click="isGiftItem ? (expandedIndex = expandedIndex === index ? null : index) : null"
                                                            >
                                                            <td class="text-center py-1 px-1">{{ index + 1 }}</td>

                                                            <td class="text-left py-1 px-1">
                                                                {{ item.product_code }}
                                                            </td>

                                                            <td class="text-left py-1 px-1" style="min-width: 150px">
                                                                {{ item.product_name }}
                                                            </td>

                                                            <td class="text-center py-1 px-1">
                                                                {{ item.unit_name }}
                                                            </td>

                                                            <td class="text-left py-1 px-1">
                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 80px"
                                                                    label="" :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="0"
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="underlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.qty" 
                                                                    hide-details="auto"
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.qty < 0"
                                                                    :error-messages="item.qty < 0 ? 'Quantity must be greater than 0' : ''"
                                                                    @update:model-value="item.total = item.qty * item.sale_rate"
                                                                    @blur="item.total = item.qty * item.sale_rate"
                                                                    >
                                                                </v-text-field>
                                                            </td>

                                                            <td v-if="isFreeItem" class="text-left py-1 px-1">
                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 80px" 
                                                                    label="" :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="1" 
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="underlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.free_qty"
                                                                    hide-details="auto"
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.free_qty < 0"
                                                                    :error-messages="item.free_qty < 0 ? 'Quantity must be greater than or equal 0' : ''"
                                                                    >
                                                                </v-text-field>
                                                            </td>

                                                            <td class="text-left py-1 px-1">
                                                                <v-text-field 
                                                                    :reverse="false" 
                                                                    controlVariant="stacked"
                                                                    style="width: 120px" 
                                                                    label="" :hideInput="false"
                                                                    :inset="false" 
                                                                    :min="0" 
                                                                    type="number" 
                                                                    density="compact"
                                                                    variant="underlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.sale_rate"
                                                                    hide-details="auto"
                                                                    @click.stop
                                                                    @focus.stop
                                                                    :error="item.sale_rate < 0"
                                                                    
                                                                    @update:model-value="item.total = item.qty * item.sale_rate"
                                                                    @blur="item.total = item.qty * item.sale_rate"
                                                                    :error-messages="item.errors?.sale_rate"
                                                                    >
                                                                </v-text-field>
                                                            </td>


                                                          <td class="text-left py-1 px-1">
                                                            <v-text-field
                                                                :reverse="false"
                                                                controlVariant="stacked"
                                                                style="width: 80px"
                                                                label="" :hideInput="false"
                                                                :inset="false"
                                                                type="text"
                                                                hide-details="auto"
                                                                density="compact"
                                                                variant="underlined"
                                                                bg-color="grey-lighten-4"
                                                                @click.stop
                                                                @focus.stop
                                                                v-model="item.lot_no"
                                                            >
                                                            </v-text-field>
                                                          </td>

                                                            <td class="text-end py-1 px-1">
                                                                {{ this.$numberFormat(item.total) }}
                                                            </td>



                                                          <td class="text-left py-1 px-1">
                                                            <v-text-field
                                                                :reverse="false"
                                                                controlVariant="stacked"
                                                                style="width: 100px"
                                                                label=""
                                                                :hideInput="false"
                                                                :inset="false"
                                                                type="text"
                                                                density="compact"
                                                                hide-details="auto"
                                                                variant="underlined"
                                                                @click.stop
                                                                @focus.stop
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.description"
                                                            >
                                                            </v-text-field>
                                                          </td>

                                                            <td style="white-space: nowrap;" class="text-center py-1 px-1">
                                                                <v-btn
                                                                    icon="mdi-delete-outline"
                                                                    size="small"
                                                                    color="error"
                                                                    variant="text"
                                                                    @click="removeFromCart(index)"
                                                                ></v-btn>

                                                                <v-btn v-if="isGiftItem" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input">
                                                                    <v-icon color="blue">mdi-gift-open</v-icon>
                                                                </v-btn>

                                                                <v-icon v-if="isGiftItem" size="small">
                                                                    {{ expandedIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                                                </v-icon>
                                                            </td>
                                                        </tr>

                                                        <tr class="pa-0" >
                                                            <td colspan="100%" class="pa-0" style="height: 0px;">
                                                                <v-expand-transition >
                                                                    <div v-if="expandedIndex === index" :key="'expand-' + index" class="d-flex flex-column">
                                                                        
                                                                            <v-table density="compact" :loading="loading" fixed-header
                                                                                class="table-dotted-border-bottom">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-center" style="width: 5%">SL</th>

                                                                                        <th class="text-left" style="width: 25%">
                                                                                            Product
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 10%">Unit</th>

                                                                                        <th class="text-left" style="width: 10%">
                                                                                            Quantity
                                                                                        </th>

                                                                                        <th class="text-left" style="width: 15%">
                                                                                            Price
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 15%">
                                                                                            Amount
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 20%">
                                                                                            Desc.
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 10%">
                                                                                            Lot No.
                                                                                        </th>
                                                                                        <th class="text-right" style="width: 5%">Action</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    <tr v-if="item.gifts.length == 0" style="" >
                                                                                        <td colspan="100%">
                                                                                        <div style="width:100%; display:flex; justify-content:center; padding:20px;">
                                                                                                <v-btn  class="bg-primary pa-2" style="height:30px; font-size:12px;" variant="flat"  @click="addGiftItem(index)"> <v-icon color="white">mdi-plus</v-icon> Gift</v-btn>
                                                                                        </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <template v-for="(giftItem, giftIndex) in item.gifts"  :key="giftIndex">
                                                                                        <tr v-if="item.gifts.length > 0" style="" >
                                                                                            <td class="text-center py-1">{{ giftIndex + 1 }}</td>

                                                                                            <td class="text-left py-1 px-0">
                                                                                                <v-autocomplete 
                                                                                                    label="Product Name" 
                                                                                                    variant="outlined"
                                                                                                    density="compact" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.product_id"
                                                                                                    :items="getProductMapList"
                                                                                                    :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" 
                                                                                                    item-value="product_id"
                                                                                                    autocomplete="off" 
                                                                                                    clearable
                                                                                                    hide-details = "auto"
                                                                                                    :error-messages="giftItem.errors?.product_id"
                                                                                                    @update:model-value="val => selectGiftItem(index, giftIndex, val)" 
                                                                                                
                                                                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                                                                </v-autocomplete>
                                                                                            </td>

                                                                                            <td class="text-center py-1 px-0">
                                                                                                {{ giftItem.unit_name }}
                                                                                            </td>

                                                                                            <td class="text-left py-1 px-0">
                                                                                                <v-text-field 
                                                                                                    :reverse="false"
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    :min="1" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined"
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.qty" 
                                                                                                    hide-details = "auto"
                                                                                                    :error="giftItem.qty < 0"
                                                                                                    :error-messages="giftItem.qty < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-left py-1 px-0">
                                                                                                <v-text-field
                                                                                                    style=""
                                                                                                    label=""
                                                                                                    :min="0" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined"
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.sale_rate"
                                                                                                    hide-details = "auto"
                                                                                                    :error="giftItem.sale_rate < 0"
                                                                                                    :error-messages="giftItem.sale_rate < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-center py-1 px-0">
                                                                                                {{ this.$numberFormat(giftItem.total) }}
                                                                                            </td>

                                                                                            <td class="text-left py-1 px-0">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 100px" 
                                                                                                    label="" 
                                                                                                    :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text"
                                                                                                    hide-details="auto"
                                                                                                    density="compact"
                                                                                                    variant="outlined"
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.description" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-left py-1 px-0">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text" 
                                                                                                    density="compact"
                                                                                                    variant="outlined"
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.lot_no" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-center py-1 px-0" style="width:200px;">
                                                                                                <div class="d-flex justify-content-center">
                                                                                                    <v-btn icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeGiftItem(index, giftIndex)">
                                                                                                        <v-icon color="red">mdi-close</v-icon>
                                                                                                    </v-btn>

                                                                                                    <v-btn v-if="giftIndex == item.gifts.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addGiftItem(index)">
                                                                                                        <v-icon color="blue">mdi-plus</v-icon>
                                                                                                    </v-btn>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template >
                                                                                </tbody>
                                                                            </v-table>

                                                                    </div>
                                                                </v-expand-transition>
                                                            </td>
                                                        </tr>
                                                    </template >
                                                </tbody>
                                                <tfoot v-if="cart.length > 0">
                                                    <tr>
                                                        <th colspan="7"
                                                            class="bg-blue-lighten-5 text-right text-uppercase font-weight-bold py-1">
                                                            Sub Total
                                                        </th>
                                                        <th class="bg-blue-lighten-5 text-end font-weight-bold py-1">
                                                            {{ this.$numberFormat(subTotal) }}
                                                        </th>

                                                        <th colspan="3" class="bg-blue-lighten-5"></th>

                                                    </tr>

                                                    <tr>
                                                        <td colspan="4" class="text-right">
                                                            Discount (10 or 10%)
                                                        </td>

                                                        <td></td>
                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                                v-model="discount_value.value.value"
                                                                density="compact"
                                                                hide-details
                                                                autocomplete="off" 
                                                                variant="underlined"
                                                            >
                                                            </v-text-field>
                                                        </td>

                                                        <td class="text-right px-1">
                                                            {{ this.$numberFormat(discountAmount) }}
                                                        </td>

                                                        <td class="text-center py-1"></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="4" class="text-right py-1">
                                                            Vat/ Tax
                                                        </td>

                                                        <td></td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-select 
                                                                v-model="taxType" 
                                                                density="compact"
                                                                variant="underlined"
                                                                :items="includeOrExclude"
                                                                item-title="label" 
                                                                item-value="value" 
                                                                hide-details
                                                                style="width: 115px"
                                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                            </v-select>
                                                        </td>

                                                        <td colspan="1" class="text-right py-1">
                                                            <v-text-field 
                                                            v-model="tax_value.value.value"  
                                                            density="compact"
                                                            hide-details 
                                                            dense
                                                            style="min-width: 70px"
                                                            autocomplete="off" 
                                                            variant="underlined"
                                                            :disabled="taxTypeDisable"
                                                            >
                                                            </v-text-field>
                                                        </td>

                                                        <td class="text-right px-1">
                                                            {{ this.$numberFormat(taxAmount) }}
                                                        </td>

                                                        <td colspan="3" class="text-center py-1"></td>
                                                    </tr>

                                                    <tr class="bg-blue-lighten-5">
                                                        <th colspan="7"
                                                            class="text-right text-uppercase font-weight-bold py-1">
                                                            Grand Total
                                                        </th>
                                                        <th class=" text-right font-weight-bold py-1 px-1">
                                                            {{ this.$numberFormat(grandTotal) }}
                                                        </th>
                                                        <th></th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>

                                                </tfoot>

                                                <tfoot v-else>
                                                  <tr >
                                                    <td colspan="10" class="text-center py-8">
                                                      <v-icon size="32" color="primary" class="mb-2">
                                                        mdi-cart-outline
                                                      </v-icon>
                                                      <div class="text-body-2 text-medium-emphasis">
                                                        No item selected
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tfoot>
                                            </v-table>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    </v-card>

                                    <v-card elevation="0" border rounded="lg" class="pa-2 mt-5">
                                      <div class="d-flex align-center mb-4">
                                        <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                                          <v-icon size="20">mdi-cash-register</v-icon>
                                        </v-avatar>
                                        <div>
                                          <div class="text-subtitle-1 font-weight-medium">Payment method</div>
                                          <div class="text-caption text-medium-emphasis">Payment and settlement details</div>
                                        </div>
                                      </div>
                                      <v-row>
                                        <v-col cols="12" md="8">
                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-select
                                                  v-model="payment_method.value.value"
                                                  :items="paymentTypes"
                                                  item-title="label"
                                                  item-value="value"
                                                  density="compact"
                                                  variant="outlined"
                                                  clearable
                                                  bg-color="grey-lighten-4"
                                                  autocomplete="off"
                                                  @update:model-value="onPaymentMethodChange"
                                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                              >
                                                <template #label>
                                                  Payment Method
                                                </template>
                                              </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                              <v-autocomplete
                                                  v-model="payment_acc_account_head_id.value.value"
                                                  :items="getPaymentAccountHeadList"
                                                  :item-title="(item) => `${item.name ?? 'Select'}`"
                                                  item-value="id"
                                                  variant="outlined"
                                                  density="compact"
                                                  bg-color="grey-lighten-4"
                                                  :loading="accountHeadingLoading"
                                                  clearable
                                                  :menu-props="{ contentClass: 'my-custom-dropdown' }"
                                              >
                                                <template #label>
                                                  Payment Head
                                                </template>
                                              </v-autocomplete>
                                            </v-col>
                                          </v-row>

                                          <v-row v-if="payment_method.value.value === 'bank'" dense>
                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                  density="compact"
                                                  v-model="cheque_no.value.value"
                                                  variant="outlined"
                                                  bg-color="grey-lighten-4"

                                                  autocomplete="off"
                                              >
                                                <template #label>
                                                  Cheque No
                                                </template>
                                              </v-text-field>

                                              <v-text-field
                                                  v-model="issuing_bank_name.value.value"
                                                  density="compact"
                                                  variant="outlined"
                                                  bg-color="grey-lighten-4"

                                                  autocomplete="off"
                                              >
                                                <template #label>
                                                  Bank Name
                                                </template>
                                              </v-text-field>

                                              <v-text-field
                                                  v-model="issuing_bank_account_no.value.value"
                                                  density="compact"
                                                  variant="outlined"
                                                  bg-color="grey-lighten-4"

                                                  autocomplete="off"
                                              >
                                                <template #label>
                                                  Account No
                                                </template>
                                              </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                              <v-date-input
                                                  input-format="dd/mm/yyyy"
                                                  density="compact"
                                                  prepend-icon=""
                                                  prepend-inner-icon="mdi-calendar"
                                                  v-model="cheque_date.value.value"
                                                  variant="outlined"
                                                  bg-color="grey-lighten-4"

                                                  autocomplete="off"
                                              >
                                                <template #label>
                                                  Cheque Date
                                                </template>
                                              </v-date-input>

                                              <v-text-field
                                                  v-model="issuing_branch_name.value.value"
                                                  density="compact"
                                                  variant="outlined"
                                                  bg-color="grey-lighten-4"

                                                  autocomplete="off"
                                              >
                                                <template #label>
                                                  Branch Name
                                                </template>
                                              </v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                          <v-text-field v-model="paid.value.value"
                                                        density="compact"
                                                        type="number"

                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        @update:model-value="onChangePayReceived"
                                          >
                                            <template #label>
                                              Advance Payment
                                            </template>
                                          </v-text-field>

                                          <v-text-field
                                              v-model="previous_due.value.value"
                                              density="compact"
                                              type="number"

                                              readonly
                                              variant="outlined"
                                              bg-color="grey-lighten-4"
                                          >
                                            <template #label>
                                              Previous Due
                                            </template>
                                          </v-text-field>

                                          <v-text-field
                                              v-model="due.value.value"
                                              density="compact"
                                              type="number"

                                              readonly
                                              variant="outlined"
                                              bg-color="grey-lighten-4"
                                          >
                                            <template #label>
                                              Total Due
                                            </template>
                                          </v-text-field>

                                          <v-date-input
                                              input-format="dd/mm/yyyy"
                                              density="compact"
                                              prepend-icon=""
                                              prepend-inner-icon="mdi-calendar"
                                              variant="outlined"
                                              bg-color="grey-lighten-4"
                                              v-model="next_payment_date.value.value"
                                              :error-messages="next_payment_date.errorMessage.value"
                                              autocomplete="off"
                                              clearable>
                                            <template #label>
                                              Next Payment Date
                                            </template>
                                          </v-date-input>

                                          <v-text-field
                                              v-model="next_payment_amount.value.value"
                                              density="compact"
                                              type="number"

                                              variant="outlined"
                                              bg-color="grey-lighten-4"
                                          >
                                            <template #label>
                                              Next Payment Approx. Amount
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>

                        </v-form>

                        <v-divider class="mt-2"></v-divider>
                        <v-card-actions>
                            <v-row align="start">
                                <v-col cols="12" md="9">
                                  <div class="d-flex justify-space-between align-center mb-2">
                                    <v-label class="text-subtitle-1 font-weight-bold">
                                      Description
                                    </v-label>
                                  </div>
                                  <Ckeditor
                                      :editor="ClassicEditor"
                                      v-model="remarks.value.value"
                                      :config="editorConfig"
                                  ></Ckeditor>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <div class="d-flex justify-end ga-2">
                                        <v-btn
                                            color="grey-darken-1"
                                            variant="flat"
                                            prepend-icon="mdi-content-save-outline"
                                            @click="submitForm(0)"
                                        >
                                            draft
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            variant="flat"
                                            prepend-icon="mdi-send-outline"
                                            @click="submitForm(1)"
                                        >
                                            Post
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </BaseCard>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { nextTick, getCurrentInstance, ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useRouter } from "vue-router";
import { getCompanyInfo } from '@/plugins/helpers'
import BaseCard from "@/components/utils/baseCard.vue";
import {Ckeditor} from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    components: {
      BaseCard,
      Ckeditor
    },
    data: () => ({
        expandedIndex: null,
        loading: false,
        errorMessages: "",
        isFreeItem:false,
        isGiftItem:false,
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
        accountHeadingLoading: false,

        vatTypeDisable: false,
        taxTypeDisable: false,

        vatType: 'include',
        taxType: 'include',
        includeOrExclude: [
            { value: 'include', label: "Include" },
            { value: 'exclude', label: "Exclude" },
            { value: 'exempted', label: "Exempted" },
        ],

        itemType: [
            { value: 'Normal', label: "Normal" },
            { value: 'Free', label: "Free" },
            { value: 'Gift', label: "Gift" },
        ],

        bankName: null,
        accountNo: "",
        mobileProvider: null,
        transactionId: "",
        contactsAddressList: [],
        paymentTypes: [
            { label: "Cash", value: "cash" },
            { label: "Bank", value: "bank" },
            { label: "Mobile Banking", value: "mobile_banking" }
        ],
        banks: [
            { label: "Al Rajhi Bank", value: "alrajhi" },
            { label: "NCB", value: "ncb" },
            { label: "Riyad Bank", value: "riyad" }
        ],
        mobileProviders: [
            { label: "Bkash", value: "bkash" },
            { label: "Nagad", value: "nagad" },
            { label: "Rocket", value: "rocket" }
        ],
    }),
    watch: {
        grandTotal(newVal) {
            this.due.value.value = parseFloat(((parseFloat(newVal || 0) + parseFloat(this.previous_due.value.value || 0)) - parseFloat(this.paid.value.value || 0)).toFixed(2));
        },
        vatType(val) {
            if (val === 'exempted') {
                this.vat_value.value.value = 0,
                this.vatTypeDisable = true;
            } else {
                this.vatTypeDisable = false;
            }
        },
        taxType(val) {
            if (val === 'exempted') {
                this.tax_value.value.value = 0,
                this.taxTypeDisable = true;
            } else {
                this.taxTypeDisable = false;
            }
        },

        isEntryMode(val) {
            if (val === false) {
                this.$store.dispatch("getSalesWorkOrderList", { lock: null });
            } else {
                return
            }
        }

    },
    created() {
        // if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        // }
        // if (this.$store.getters.getLcBankList.length === 0) {
            this.$store.dispatch("getLcBankList");
        // }
        // if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        // }

        if (this.isEntryMode === true) { 
            this.$store.dispatch("getSalesWorkOrderList", { lock: 0 });
        }

        // if (this.$store.getters.getHrmEmployeeList.length === 0) {
            this.$store.dispatch("getHrmEmployeeList", {is_all_branch:true});
        // }
    },
    computed: {

        subTotal() {
            return this.cart.reduce((sum, item) => +sum + +item.total, 0);
        },

        discountAmount() {
            if (!this.discount_value?.value.value) {
                this.discount_value.value.value = 0;
                this.discount_method.value.value = 'flat';
                this.discount_type.value.value = null;
                return 0;
            } 

            const val = this.discount_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.discount_method.value.value = 'percent';
                this.discount_type.value.value = 1;
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            this.discount_method.value.value = 'flat';
            this.discount_type.value.value = 2;
            return parseFloat(val) || 0;
        },
        subtotalAfterDiscount() {
            return this.subTotal - this.discountAmount;
        },
        taxAmount() {
            if (!this.tax_value?.value.value) {
                this.tax_value.value.value = 0;
                this.tax_method.value.value = 'flat';
                return 0;
            } 

            const val = this.tax_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.tax_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subtotalAfterDiscount * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        vatAmount() {
            if (!this.vat_value.value.value) {
                this.vat_value.value.value = 0;
                this.vat_method.value.value = 'flat';
                return 0;
            } 

            const val = this.vat_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.vat_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subtotalAfterDiscount * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        grandTotal() {
            const discount = this.discountAmount;
            const vat = this.vatType === 'include' ? this.vatAmount : 0;
            const tax = this.taxType === 'include' ? this.taxAmount : 0;
            return this.subTotal + vat + tax - discount;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },
        
        getPaymentAccountHeadList() {
            return this.$store.getters.getPaymentAccountHeadList;
        },
        getLcBankList() {
            return this.$store.getters.getLcBankList;
        },

        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        filteredWorkOrderList() {
            const workorders = this.$store.getters.getSalesWorkOrderList || [];
            return workorders.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getHrmEmployeeList() {
            return this.$store.getters.getHrmEmployeeList;
        },
    },
    methods: {
        onCustomerChange(val) {
            if (val) {
                this.contactAddressLoading = true
                this.$store.dispatch("getCustomerById", val)
                    .then((res) => {
                        this.sales_person_id.value.value = res.dealing_person_id;
                        // this.delivery_address.value.value = res.company_address;
                        console.log(res);
                        this.contactsAddressList = res?.contacts || [];

                        this.contactAddressLoading = false;
                    })
            } else {
                this.sales_person_id.value.value = null;
                this.delivery_address.value.value = null;
                this.contactsAddressList = []

                this.contactAddressLoading = false
            }
        },
        onPaymentMethodChange() {
            if (this.payment_method.value.value) {
                this.$store.dispatch("getPaymentAccountHeadList", { 
                    type: this.payment_method.value.value 
                });

                this.payment_acc_account_head_id.value.value = null;
            } else {
              this.$store.commit("UNSET_PAYMENT_ACCOUNT_HEAD_LIST");
            }
        },
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );
            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                qty: 1,
                free_qty: 0,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
                purchase_rate: product.purchase_rate,
                sale_rate: product.latest_sale_rate,
                description: product.description,
                total: product.latest_sale_rate,
                gifts: [],
            };

            this.cart.push(item);

            console.log(this.cart);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },

        addGiftItem(index) {
            let item = this.cart[index];

            if (!item.gifts) {
                this.$set(item, "gifts", []);
            }

            item.gifts.push({
                product_id: null,
                qty: 1,
                sale_rate: 0,
                total: 0,
                lot_no: '',
                description: '',
            });
        },

        removeGiftItem(index, giftIndex) {
            // if (confirm("Remove this gift item?")) {
                this.cart[index].gifts.splice(giftIndex, 1);
            // }
        },

        selectGiftItem(index, giftIndex, selectedProductId) {
            
            let item = this.cart[index];

            if(!selectedProductId){
                item.gifts[giftIndex].product_id = null;
                item.gifts[giftIndex].unit_name = '';
            }

            const exists = item.gifts.some(
                (g, i) => g.product_id == selectedProductId && i !== giftIndex
            );

            if (exists) {
                toast.error("The Item Already added!");
                item.gifts[giftIndex].product_id = null;
                return;
            }
            let productObj = this.getProductMapList.find(p => p.product_id == selectedProductId )?.product;
            if (productObj) {
                item.gifts[giftIndex].product_id = selectedProductId;
                item.gifts[giftIndex].unit_name = productObj.unit?.name || '';
            }
        },

        cartReset() {
            // this.product_id.setValue(null);
            // this.product_id = null;
            //console.log(this.product_id.value)
        },
        onChangePayReceived() {
            this.due.value.value = (parseFloat(this.grandTotal || 0) + parseFloat(this.previous_due.value.value)) - parseFloat(this.paid.value.value);
        },
        async onWorkorderChange(selectedId) {

            if (!selectedId) {
                this.order_category.value.value = null;
                this.cart = [];
                return;
            }

            try {
                const data = await this.$store.dispatch("getSalesWorkOrderById", selectedId);
                const workOrder = data.data; 
                this.customer_id.value.value = workOrder.customer?.id
                this.ref_no.value.value = workOrder.proposal.ref_no || "";

                this.cart = [];
                (workOrder.proposal.details || []).forEach((item) => {
                    this.cart.push({
                        product_id: item.product_id,
                        product_name: item.product?.name || "",
                        product_code: item.product?.code || "",
                        qty: item.qty,
                        unit_id: item.product?.unit_id || "",
                        unit_name: item.product?.unit?.name || "",
                        purchase_rate: item.purchase_rate,
                        sale_rate: item.sale_rate,
                        lot_no: item.lot_no,
                        description: item.description,
                        total: item.qty * item.sale_rate,
                        gifts:[]
                    });
                });
                this.$store.commit("UNSET_LOADING");
            } catch (error) {
                console.error("Failed to load requisition data:", error);
            }
        },
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                sale_order_date: yup.date().required().label("Purchase Order Date"),
                shipping_date: yup.date().nullable().label("Shipping Date"),
                // payment_terms: yup.number().positive().integer().nullable().label("Customer Name"),
                // approximate_delivery_date: yup.date().nullable().label("Approximate Delivery Date"),
                delivery_address: yup.string().nullable().label('Address'),
                ref_no: yup.string().nullable().label('ref no'),
                po_no: yup.string().nullable().label('PO No'),
                po_date: yup.date().nullable().label("PO Date"),
                order_category: yup.string().required().label("Order Category"),
                workorder_id: yup.number().positive().integer().nullable().label("Work Order"),
                customer_id: yup.number().positive().integer().required().label("Customer Name"),
            }),
        });

        const product_id = useField("product_id");
        const sale_order_master_id = useField("sale_order_master_id");
        const employee_id = useField("employee_id");
        const sales_person_id = useField("sales_person_id");
        const order_category = useField("order_category");
        const workorder_id = useField("workorder_id");
        const customer_id = useField("customer_id");
        const shipping_date = useField("shipping_date");
        // const approximate_delivery_date = useField("approximate_delivery_date");
        const delivery_address = useField("delivery_address");
        const ref_no = useField("ref_no");
        const po_no = useField("po_no");
        const po_date = useField("po_date");
        const payment_bank_id = useField("payment_bank_id");
        // const payment_terms = useField("payment_terms");

        const discount_value = useField("discount_value");
        const discount_method = useField("discount_method");
        const discount_type = useField("discount_type");
        const discount_amount = useField("discount_amount");
        const tax_amount = useField("tax_amount");
        const tax_value = useField("tax_value");
        const tax_type = useField("tax_type");
        const tax_method = useField("tax_method");
        const vat_amount = useField("vat_amount");
        const vat_value = useField("vat_value");
        const vat_type = useField("vat_type");
        const vat_method = useField("vat_method");

        const status = useField("status");

        const payment_method = useField("payment_method");
        const payment_acc_account_head_id = useField("payment_acc_account_head_id");
        const cheque_no = useField("cheque_no");
        const cheque_date = useField("cheque_date");
        const issuing_bank_name = useField("issuing_bank_name");
        const issuing_branch_name = useField("issuing_branch_name");
        const issuing_bank_account_no = useField("issuing_bank_account_no");

        const sale_order_date = useField("sale_order_date");
        const saleOrder_by = useField("saleOrder_by");
        const saleOrder_by_mobile = useField("saleOrder_by_mobile");
        const saleOrder_by_email = useField("saleOrder_by_email");
        const total = useField("total");
        const paid = useField('paid');
        const previous_due = useField('previous_due');
        const due = useField('due');
        const next_payment_date = useField('next_payment_date');
        const next_payment_amount = useField('next_payment_amount');
        const remarks = useField("remarks");
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.sub_total = proxy.subTotal;

            values.discount_amount = proxy.discountAmount;
            values.discount_type = discount_type.value.value;
            
            values.tax_amount = proxy.taxAmount;
            values.tax_type = proxy.taxType;

            values.vat_amount = proxy.vatAmount;
            values.vat_type = proxy.vatType;

            values.total = proxy.grandTotal;

            values.cart = cart.value;
            values.sale_order_date = formattedDate(sale_order_date.value.value);
            values.po_date = formattedDate(po_date.value.value);
            values.shipping_date = formattedDate(shipping_date.value.value);
            // values.approximate_delivery_date = formattedDate(approximate_delivery_date.value.value);
            values.delivery_address = delivery_address.value.value;
            values.ref_no = ref_no.value.value;
            values.paid = paid.value.value;
            values.previous_due = previous_due.value.value;
            values.due = due.value.value;
            values.next_payment_date = formattedDate(next_payment_date.value.value);
            values.next_payment_amount = next_payment_amount.value.value;
            store.dispatch("saveUpdateSaleOrder", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-order-record" });
                    }, 2000);
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.errors) {
                        const errors = error.response.data.errors;

                        // reset previous errors
                        cart.value.forEach(item => {
                            item.errors = {};
                        });

                        let expandedRows = [];

                        Object.keys(errors).forEach((key) => {
                            const message = errors[key][0];

                            // cart.0.qty OR cart.0.gifts.1.qty
                            const match = key.match(/cart\.(\d+)(?:\.gifts\.(\d+))?\.(.+)/);

                            if (match) {
                                const cartIndex = parseInt(match[1]);
                                const giftIndex = match[2] !== undefined ? parseInt(match[2]) : null;
                                const field = match[3];

                                if (!cart.value[cartIndex]) return;

                                if (giftIndex === null) {
                                    if (!cart.value[cartIndex].errors) {
                                        cart.value[cartIndex].errors = {};
                                    }

                                    cart.value[cartIndex].errors[field] = message;

                                    expandedRows.push(cartIndex);
                                }

                                else {
                                    if (!cart.value[cartIndex].gifts[giftIndex].errors) {
                                        cart.value[cartIndex].gifts[giftIndex].errors = {};
                                    }

                                    cart.value[cartIndex].gifts[giftIndex].errors[field] = message;

                                    expandedRows.push(cartIndex);
                                }
                            }
                        });

                        if (expandedRows.length > 0) {
                            proxy.expandedIndex = expandedRows[0];
                        }

                        const messages = Object.values(errors).flat().join('\n');
                        toast.error(messages);

                    } else {
                        toast.error(error.response?.data?.message || 'Something went wrong');
                    }
                });
        });

        return {
            submitForm,
            submit,
            product_id,
            sale_order_date,
            shipping_date,
            // approximate_delivery_date,
            delivery_address,
            ref_no,
            po_no,
            po_date,
            payment_bank_id,
            // payment_terms,
            remarks,
            
            payment_method,
            payment_acc_account_head_id,
            cheque_no,
            cheque_date,
            issuing_bank_name,
            issuing_branch_name,
            issuing_bank_account_no,

            discount_value,
            discount_method,
            discount_amount,
            discount_type,
            tax_amount,
            tax_value,
            tax_method,
            tax_type,
            vat_amount,
            vat_value,
            vat_method,
            vat_type,
            status,
            total,
            paid,
            previous_due,
            due,
            next_payment_date,
            next_payment_amount,
            cart,
            saleOrder_by,
            saleOrder_by_mobile,
            saleOrder_by_email,
            errorMessages,
            employee_id,
            sales_person_id,
            order_category,
            workorder_id,
            customer_id,
            sale_order_master_id,
            buttonText,
            loading,
            getCompanyInfo,
            ClassicEditor,
            editorConfig: {
              toolbar: {
                items: [
                  "heading", "|", "bold", "italic", "underline", "|", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "blockQuote", "|", "undo", "redo",
                ],
              },
              language: "en",
            },
        };
    },

    mounted() {

        this.isGiftItem = getCompanyInfo()?.is_gift_item ?? false;
        this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;

        this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.saleOrder_by.value.value = user.full_name;
        this.saleOrder_by_mobile.value.value = user.mobile;
        this.saleOrder_by_email.value.value = user.email;
        
        const workorderId = this.$route.query.workorder_id;

        if(workorderId) {
            this.$watch(() => this.filteredWorkOrderList,
                (list) => {
                    if (list && list.length > 0) {
                        const match = list.find(i => String(i.id) === String(workorderId));
                        if (match) {
                            this.workorder_id.value.value = Number(workorderId);
                            this.onWorkorderChange(Number(workorderId));
                        }
                    }
                },
                { immediate: true }
            );
        }

        const id = this.$route.query.id;

        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                    .dispatch("getSaleOrderById", id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let saleOrder = data;
                        this.sale_order_master_id.value.value = saleOrder.id;
                        this.sale_order_date.value.value = saleOrder.sale_order_date ? new Date(saleOrder.sale_order_date) : new Date();
                        this.shipping_date.value.value = saleOrder.shipping_date ? new Date(saleOrder.shipping_date) : new Date();
                        // this.approximate_delivery_date.value.value = saleOrder.approximate_delivery_date ? new Date(saleOrder.approximate_delivery_date) : new Date();
                        // this.payment_terms.value.value = saleOrder.payment_terms;
                        this.ref_no.value.value = saleOrder.ref_no;
                        this.po_no.value.value = saleOrder.po_no;
                        this.po_date.value.value = saleOrder.po_date;
                        this.payment_bank_id.value.value = saleOrder.payment_bank_id;
                        this.order_category.value.value = saleOrder.order_category;
                        this.workorder_id.value.value = saleOrder.workorder_id;
                        this.employee_id.value.value = saleOrder.employee_id;
                        this.sales_person_id.value.value = saleOrder?.sales_person_id;

                        this.discount_method.value.value = saleOrder.discount_method;
                        this.discount_value.value.value = this.discount_method.value.value == 'percent'? saleOrder.discount_value + '%' : saleOrder.discount_value;

                        this.tax_method.value.value = saleOrder.tax_method;
                        this.tax_value.value.value = this.tax_method.value.value == 'percent'? saleOrder.tax_value + '%' : saleOrder.tax_value;
                        this.taxType = saleOrder.tax_type;

                        this.vat_method.value.value = saleOrder.vat_method;
                        this.vat_value.value.value = this.vat_method.value.value == 'percent'? saleOrder.vat_value + '%' : saleOrder.vat_value;
                        this.vatType = saleOrder.vat_type;

                        this.paid.value.value = saleOrder.paid;
                        this.previous_due.value.value = saleOrder.previous_due;
                        this.due.value.value = saleOrder.due;
                        this.next_payment_date.value.value = saleOrder.next_payment_date ? new Date(saleOrder.next_payment_date) : new Date();
                        this.next_payment_amount.value.value = saleOrder.next_payment_amount;
                        this.status.value.value = saleOrder.status;
                        this.product_id.value.value = null;
                        this.customer_id.value.value = saleOrder.customer_id;
                        this.contactsAddressList = (saleOrder?.customer?.contacts || []).map(c => ({
                          ...c,
                          address: c.address?.trim(),
                        }));

                        this.delivery_address.value.value = saleOrder.delivery_address?.trim();
                        console.log(this.delivery_address.value.value)
                        this.payment_method.value.value = saleOrder?.voucher_master?.payment_method?.toLowerCase();
                        this.onPaymentMethodChange();
                        this.payment_acc_account_head_id.value.value = saleOrder?.voucher_master?.payment_acc_account_head_id;
                        this.cheque_no.value.value = saleOrder?.voucher_master?.cheque_no;
                        this.cheque_date.value.value = saleOrder?.voucher_master?.cheque_date ? new Date(saleOrder?.voucher_master?.cheque_date) : null;
                        this.issuing_bank_name.value.value = saleOrder?.voucher_master?.issuing_bank_name;
                        this.issuing_branch_name.value.value = saleOrder?.voucher_master?.issuing_branch_name;
                        this.issuing_bank_account_no.value.value = saleOrder?.voucher_master?.issuing_bank_account_no;
                        // this.mobileProvider = saleOrder?.voucher_master?.mobile_provider;
                        // this.transactionId = saleOrder?.voucher_master?.transaction_id;
                        this.remarks.value.value = saleOrder.remarks ? saleOrder.remarks : "";

                        this.cart.value = [];

                        // Insert items one by one
                        (saleOrder.details || []).forEach((item) => {
                            this.cart.push({ 
                                product_id: item.product_id,
                                product_name: item.product?.name || "",
                                product_code: item.product.code,
                                free_qty: item.free_qty,
                                qty: item.quantity,
                                unit_id: item.product.unit_id || "",
                                unit_name: item.product.unit?.name || "",
                                purchase_rate: item.purchase_rate,
                                sale_rate: item.sale_rate,
                                total: item.total,
                                lot_no: item.lot_no,
                                description: item.description,
                                gifts: (item.gifts || []).map(g => ({
                                    product_id: g.product_id,
                                    qty: g.quantity || 1,
                                    sale_rate: g.sale_rate || 0,
                                    total: g.total || 0,
                                    lot_no: g.lot_no || '',
                                    description: g.description || '',
                                }))
                            });
                        });

                        this.$store.commit("UNSET_LOADING");
                    })
                    .catch((error) => {
                        this.$store.commit("UNSET_LOADING");
                        console.error("Failed to fetch rfq:", error);
                    });
            });
        } else {
            this.sale_order_master_id.value.value = "";
            this.payment_bank_id.value.value = null;
            this.sale_order_date.value.value = new Date();
            this.shipping_date.value.value = new Date();
            // this.approximate_delivery_date.value.value = new Date();
            this.next_payment_date.value.value = new Date();
            this.next_payment_amount.value.value = 0;
            this.paid.value.value = 0;
            this.previous_due.value.value = 0;
            this.remarks.value.value = `
              <ul>
                  <li>The supplied product must be <strong>brand new, genuine.</strong></li>
                  <li>Payment: Account pay cheque &ndash; after delivery of Goods</li>
                  <li>Excluding VAT-TAX</li>
                  <li>The warranty shall be <strong>1 years limited warranty</strong> as specified by the manufacturer</li>
                  <li>Delivery shall be made to the location specified by <strong>Remex ingredient Solution.</strong></li>
              </ul>
              <p>Please take necessary action in this regard.</p>
            `
            this.due.value.value = 0;
            this.isEntryMode = true;
        }
    },
};
</script>
